import styled from 'styled-components';

export const SuccessWrapperFinish = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
` ;

export const WrapperTitle = styled.div`
  margin-top: var(--spacing-regular);
    text-align: center;
`
